import React from 'react';
import { Box, Image, Preloader, Text, useAutoFontSize } from '@common-fe/common-fe';

import DashboardIllustration from '@/assets/dashboard/dashboard-illustration.svg';
import FullDashboardIllustration from '@/assets/dashboard/full-dashboard-illustration.svg';
import { useNumberFormat } from '@/utils';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import BannerItem from './BannerItem';

interface Props {
  isWideMode?: boolean;
  total?: number;
  isLoading?: boolean;
}
const EmployeesBlock: React.FC<Props> = ({ isWideMode, total, isLoading }) => {
  const totalFormatted = useNumberFormat(`${total || 0}`);
  const { containerRef, fontSize } = useAutoFontSize(`${totalFormatted}`, {
    maxFontSize: 40,
  });

  return (
    <Box data-testid="dashboard_banner_employees-block" direction="column" style={{ flex: 1 }}>
      <BannerItem fill align="end" justify="center" overflow="hidden">
        <Image
          data-testid="dashboard_banner_employees-block_illustration"
          src={
            isWideMode
              ? whiteLabelingConfig?.images?.fullDashboardIllustration || FullDashboardIllustration
              : whiteLabelingConfig?.images?.dashboardIllustration || DashboardIllustration
          }
          style={{ position: 'absolute', right: 0, left: 0, bottom: 0, top: 0, zIndex: 1 }}
        />

        {isLoading ? (
          <Preloader data-testid="dashboard_banner_employees-block_loader" size={32} />
        ) : (
          <Box
            data-testid="dashboard_banner_employees-block_content"
            align="end"
            justify="center"
            margin={{ bottom: 'spacing8' }}
            style={{ zIndex: 2 }}
          >
            <Box ref={containerRef as React.Ref<HTMLDivElement>}>
              <BannerItem.Title
                data-testid="dashboard_banner_employees-block_total"
                size={`${fontSize}px`}
                weight={700}
              >
                {totalFormatted}
              </BannerItem.Title>
            </Box>
            <Box margin={{ left: 'spacing24' }}>
              <Text
                data-testid="dashboard_banner_employees-block_label"
                textAlign="end"
                color="textOnColor"
                style={{
                  opacity: 0.5,
                }}
              >
                Total Employees
              </Text>
            </Box>
          </Box>
        )}
      </BannerItem>
    </Box>
  );
};

export default EmployeesBlock;
